module.exports = __webpack_public_path__ + "static/media/img_location.bb082753.svg";